import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from './../http-client/http-client.service';

@Injectable()
export class UserService {

    constructor(
        private http: HttpClientService
    ) { }

    public getAll() {
        const url: string = 'users/all';
        return this.http.get(url).map(response => response.json())
        .catch(this.handleError);
    }

    public getAllByRol(userid,roleId) {
        const url: string = 'users/allbyrol/'+ userid + '/' + + roleId;
        return this.http.get(url).map(response => response.json())
        .catch(this.handleError);
    }

    public getLanguageByUserId(userId: string) {
        const url: string = 'users/language/' + userId;
        return this.http.get(url).map(response => response.json())
        .catch(this.handleError);
    }

    public editLanguageByUserId(userId: string, language: string) {
        const url: string = 'users/language';
        return this.http.put(url, {
            UserId: userId,
            Language: language
        }).map(response => response.json())
            .catch(this.handleError);
    }

    public add(id: string, email: string, password: string, confirmPassword: string, firstName: string, lastName: string, phoneNumber: string, documentNumber: string, applicationRoleId: string, photo: string, shifts: any) {
        const url = 'Account/Register';
        return this.http.post(url, {
            Id: id,
            Email: email,
            Password: password,
            ConfirmPassword: confirmPassword,
            FirstName: firstName,
            LastName: lastName,
            PhoneNumber: phoneNumber,
            DocumentNumber: documentNumber,
            ApplicationRoleId: applicationRoleId,
            Photo: photo,
            Shifts: shifts
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public edit(id: string, firstName: string, lastName: string, phoneNumber: string, documentNumber: string, applicationRoleId: string, photo: string, shifts: any) {
        const url = 'users/edit';
        return this.http.put(url, {
            Id: id,
            FirstName: firstName,
            LastName: lastName,
            PhoneNumber: phoneNumber,
            DocumentNumber: documentNumber,
            ApplicationRoleId: applicationRoleId,
            Photo: photo,
            Shifts: shifts
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public editSuperAdmin(id: string, firstName: string, lastName: string, phoneNumber: string, documentNumber: string, photo: string) {
        const url = 'users/edit/superadmin';
        return this.http.put(url, {
            Id: id,
            FirstName: firstName,
            LastName: lastName,
            PhoneNumber: phoneNumber,
            DocumentNumber: documentNumber,
            Photo: photo
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public setPasswordByUserId(userId: string, newPassword: string, confirmNewPassword: string) {
        const url = 'Account/SetPasswordByUserId';
        return this.http.post(url, {
            UserId: userId,
            NewPassword: newPassword,
            ConfirmPassword: confirmNewPassword
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public delete(id: string) {
        const url: string = 'users/delete/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/users/user.service.ts